import VoucherRegister from "./VoucherRegister";

export default VoucherRegister;
